import type { RouteRecordRaw } from 'vue-router'

const systemRoutes: RouteRecordRaw[] = [
  {
    path: 'system/org',
    name: 'OrgStructure',
    component: () => import('@/pages/org/index.vue'),
    meta: { title: '组织架构', parent: '配置' },
  },
  {
    path: 'system/roles',
    name: 'Roles',
    component: () => import('@/pages/roles/index.vue'),
    meta: { title: '角色管理', parent: '配置' },
  },
  {
    path: 'system/roles/editor/:id?',
    name: 'RoleEditor',
    component: () => import('@/pages/roles/editor.vue'),
    meta: { title: '角色配置', parent: '配置' },
  },
  {
    path: 'system/user-operation-logs',
    name: 'UserOperationLogs',
    component: () => import('@/pages/user-operation-log/index.vue'),
    meta: { title: '操作日志', parent: '系统管理' },
  },
  // {
  //   path: 'system/audit',
  //   name: 'AuditLog',
  //   component: () => import('@/pages/audit/index.vue'),
  //   meta: { title: '审计日志', parent: '系统管理' },
  // },
]

export default systemRoutes
